module.exports = __webpack_public_path__ + "static/img/benqi.890b7eb4.png";